import decsupplierList from './supplierList.vue'
import decsupplierEdit from './supplierEdit.vue'
import decsupplierInfo from "./supplierInfo.vue"



let a = Object.assign({ decsupplierList, decsupplierEdit, decsupplierInfo })
export default a